<template>
  <div class="user-admin">
    <hr>
  </div>
</template>
<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
export default {
  nome: 'UserAdmin',
  data: function () {
    return {
      mode: 'save',
      user: {},
      users: [],
      fields: [
        { key: 'id', label: 'Código', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'email', label: 'E-mail', sortable: true },
        {
          key: 'admin',
          label: 'Administrador',
          sortable: true,
          formatter: value => value ? 'Sim' : 'Não'
        },
        { key: 'actions', label: 'Ações' }
      ]
    }
  },
  methods: {
    loadUsers () {
      const url = `${baseApiUrl}/users`
      axios.get(url).then(res => {
        this.users = res.data
      })
    },
    reset () {
      this.mode = 'save'
      this.user = {}
      this.loadUsers()
    },
    save () {
      const method = this.user.id ? 'put' : 'post'
      const id = this.user.id ? `/${this.user.id}` : ''
      axios[method](`${baseApiUrl}/users${id}`, this.user)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    remove () {
      const id = this.user.id
      axios.delete(`${baseApiUrl}/users/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    loadUser (user, mode = 'save') {
      this.mode = mode
      this.user = { ...user }
    }
  },
  mounted () {
    this.loadUsers()
  }
}
</script>

<style>
</style>
